import { render, staticRenderFns } from "./SitesLayout.vue?vue&type=template&id=06103fa2&scoped=true"
import script from "./SitesLayout.vue?vue&type=script&lang=js"
export * from "./SitesLayout.vue?vue&type=script&lang=js"
import style0 from "./SitesLayout.vue?vue&type=style&index=0&id=06103fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06103fa2",
  null
  
)

export default component.exports